import * as Yup from 'yup';
import moment from 'moment';
import createArea from './createAreaFormModel';
const {
  formField: {
    // DATOS AREA
    name,
    description,
    sucursal,
  },
} = createArea;

export default [
  Yup.object().shape({
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),
    [description.name]: Yup.string().required(`${description.requiredErrorMsg}`),
    [sucursal.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${sucursal.requiredErrorMsg}`),
  }),
];
